import { combineReducers } from "redux";
import { get as _get } from "lodash";

import actionTypes from "../actions";

const initialMapping = { showModal: false, data: {}, success: {}, successMessage: "" };
const dataMapping = (state = initialMapping, action) => {
  switch (action.type) {
    case actionTypes.UPLOAD_READ_FILE_SUCCESS:
      const showModal = _get(action, "payload.showModel", true)
      return { showModal, data: _get(action, "payload.data", {}), success: {}, successMessage: "" };

    case actionTypes.SAVE_UPLOAD_MAPPING_DATA_SUCCESS:
      return { showModal: false, data: {}, success: _get(action, "payload.data", {}), successMessage: _get(action, "payload.message", {}) };

    case actionTypes.RESET_DATA_MAPPING_CONFIG:
    case actionTypes.RESET_CAMPAIGN_SETUP:
      return { ...initialMapping };

    default:
      return state;
  }
}

const dataMappingErrors = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.UPLOAD_READ_FILE_ERROR:
      return (action.payload || {});

    case actionTypes.SAVE_UPLOAD_MAPPING_DATA_ERROR:
      return (action.error || {});

    case actionTypes.RESET_DATA_MAPPING_CONFIG:
    case actionTypes.RESET_DATA_MAPPING_ERROR:
    case actionTypes.RESET_CAMPAIGN_SETUP:
      return {};

    default:
      return state;
  }
}

const initialRemoveUploadState = { status: null, message: "" };
const removeUpload = (state = initialRemoveUploadState, action) => {
  switch (action.type) {
    case actionTypes.REMOVE_UPLOADED_FILE_SUCCESS:
      return { status: true, message: _get(action, "payload.message", "") };

    case actionTypes.REMOVE_UPLOADED_FILE_ERROR:
      return { status: false, message: _get(action, "error.message", "") };

    case actionTypes.RESET_REMOVE_UPLOADED_FILE:
      return initialRemoveUploadState;

    default:
      return state;
  }
}


export default {
  fileUpload: combineReducers({
    dataMapping,
    errors: dataMappingErrors,
    removeUpload,
  })
}
